module.exports = __webpack_public_path__ + "img/pandu.28fddf59.png";